import { gql, graphql } from "react-apollo"
import { GetAttractLoopsQuery } from "./withAttractLoops"
import type { AttractLoop } from "../types"

const MUTATE_CREATE_ATTRACT_LOOP = gql`
  mutation CreateAttractLoop($attractLoop: AttractLoopInput!) {
    createAttractLoop(attractLoop: $attractLoop) {
      id
      title
    }
  }
`

const mutateCreateAttractLoop = graphql(MUTATE_CREATE_ATTRACT_LOOP, {
  name: "mutateCreateAttractLoop",
  options: {
    refetchQueries: [{ query: GetAttractLoopsQuery, variables: { query: "" } }]
  },
  props: ({ mutateCreateAttractLoop }) => ({
    createAttractLoop: (attractLoop: AttractLoop) =>
      mutateCreateAttractLoop({
        variables: { attractLoop }
      })
  })
})

export default mutateCreateAttractLoop



// WEBPACK FOOTER //
// ./src/AttractLoops/queries/mutateCreateAttractLoop.js